import { render, staticRenderFns } from "./resetPw.vue?vue&type=template&id=539696d7&scoped=true&"
import script from "./resetPw.vue?vue&type=script&lang=js&"
export * from "./resetPw.vue?vue&type=script&lang=js&"
import style0 from "./resetPw.vue?vue&type=style&index=0&id=539696d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539696d7",
  null
  
)

export default component.exports